import { themeIdToSegment } from './themeRoute'

// De celsleutel in en uit de URL, onder het thema. Zelfde regels als de
// thema-sleutel: '|' en ':' mogen niet rauw in een padsegment, en de router
// levert het segment half ontcijferd terug.
// AI-CONTEXT: See docs/features/intelligence-mechanisme-detail.md

// Zelfde vorm als buildCellId in functions/insightStrength/computeCellsForEffect.js.
const CELL_ID = /^msi:([^|]+)\|dim:([^|]+)\|seg:(.+)$/

// AI-CONTEXT: See docs/pitfalls.md#database-url-sentinel-string-persisted
const SENTINELS = new Set(['undefined', 'null', 'NaN'])

/**
 * @param {string|undefined} segment - het padsegment zoals de router het geeft
 * @returns {string|null} de celsleutel, of null als het er geen is
 */
export const segmentToCellId = (segment) => {
    if (typeof segment !== 'string' || !segment) return null
    let id
    try {
        id = decodeURIComponent(segment)
    } catch (e) {
        return null
    }
    const m = CELL_ID.exec(id)
    if (!m) return null
    if (SENTINELS.has(m[1]) || SENTINELS.has(m[3])) return null
    return id
}

/**
 * @param {string} client - CompagnyID uit de URL
 * @param {string} themeId - thema-sleutel
 * @param {string} cellId - celsleutel
 * @returns {string}
 */
export const cellDetailPath = (client, themeId, cellId) =>
    `/${client}/intelligence/thema/${themeIdToSegment(themeId)}/cel/${encodeURIComponent(String(cellId || ''))}`
